var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('customer-form',{attrs:{"loading":_vm.loading,"customerData":_vm.customer,"formErrors":_vm.formErrors,"billing-address-same-as-customer-value":true},on:{"customerSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }